<template>
    <div class="advertisement-disclosure">
        <div class="module__container">
            <div class="advertisement-disclosure__content">
                <span class="advertisement-disclosure__content__text">
                    {{ defaultDisclaimer }}
                </span>
                <div class="rating-disclosure" @click="toggleRatingDisclosure">
                    <span class="rating-disclosure-title">{{
                        $t('How do we rate?')
                    }}</span>
                    <span
                        v-if="ratingInfoOpen"
                        class="rating-disclosure-content"
                    >
                        {{ ratingContent }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdsenseAdvertisementDisclosure',
    props: {
        isDbl: {
            type: Boolean,
        },
    },
    data() {
        return {
            ratingInfoOpen: false,
            defaultDisclaimer: this.$t(
                `I may receive advertising fees from some of the brands I review. However, that does not affect the ranking and scoring of these brands.`
            ),
        };
    },
    computed: {
        ratingContent() {
            return this.isDbl
                ? this.$t('Rating info new')
                : this.$t('Rating info text');
        },
    },
    methods: {
        toggleRatingDisclosure() {
            this.ratingInfoOpen = !this.ratingInfoOpen;
            this.ratingDisclosureEvent(this.ratingInfoOpen);
        },
        ratingDisclosureEvent(toggleValue) {
            if (!window.track) return;
            window.track.event({
                event: 'rating_disclosure',
                action: toggleValue === true ? 'open' : 'close',
            });
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/mixins';
.advertisement-disclosure {
    background: var(--background);
    width: 100%;
    position: relative;

    .module__container {
        max-width: 1280px;
        margin: 0 auto;
        padding: 0 10px;
        display: flex;
        flex-direction: column;
        gap: 20px;

        @include mq('tablet') {
            margin: 0 auto;
            padding: 0 10px;
        }

        @include mq('desktop') {
            padding: 0 32px;
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        color: var(--secondary);
        padding: 6px 0;
        text-align: center;

        @include mq('tablet') {
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            gap: 16px;
        }

        &__text {
            width: 100%;
            font-size: 12px;
            display: flex;
            justify-content: flex-start;

            @include mq('tablet') {
                flex: 1 0 70%;
                font-size: 14px;
            }
        }
    }

    .rating-disclosure {
        margin-top: 0;
        padding: 0;
        line-height: inherit;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: var(--secondary);

        @include mq('tablet') {
            font-size: 14px;
            justify-content: flex-end;
        }
    }

    .rating-disclosure-content {
        box-shadow: 0 4px 6px -1px rgb(0 0 0/0.1), 0 2px 4px -2px rgb(0 0 0/0.1);
        border: 1px solid var(--border-color);
        width: 24rem;
        font-size: 14px;
        padding: 16px;
        border-radius: 8px;
        position: absolute;
        top: 100%;
        margin-top: 10px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 100;
        background-color: white;

        @include mq('tablet') {
            top: 40px;
            right: 16px;
            left: auto;
            margin-top: 0;
            transform: translateX(0);
        }
    }

    .rating-disclosure-title {
        cursor: pointer;
    }
}
</style>
